import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function listIntakeForms(onBehalfOf?: string) {
  const res = await fetchOrchidAPI(
    `/api/notes/v1/forms/intake/${
      onBehalfOf ? `?on_behalf_of=${onBehalfOf}` : ""
    }`,
  );

  if (!res.ok) {
    const responseText = await res.text();
    throw new Error(getErrorDetail(responseText));
  }

  return res.json();
}
